module.exports = __webpack_public_path__ + "img/bg.35d8755e.png";